export function validateId(id: string) {
  const idRegex = /^\d{3}$/
  if (!idRegex.test(id)) {
    return 'Must be 000-999'
  }
  return ''
}
